import { Pipe, PipeTransform } from '@angular/core';

import {
  isProductActive,
  isUserAllowedToAccessToProduct,
} from 'src/app/constants/constants';

@Pipe({ name: 'hasUserEpp' })
export class HasUserEppPipe implements PipeTransform {
  transform(
    stationId: any,
    isMaster: boolean,
    customerAlias: any,
    customerDocument: any,
    hasUserWebAccess: boolean,
    userMetaData: any,
    isUserAdminMode?: boolean
  ) {
    if (
      isProductActive(
        isMaster,
        customerAlias,
        customerDocument,
        hasUserWebAccess,
        userMetaData,
        'eppProducts'
      )
    ) {
      for (const eppProduct of customerDocument['eppProducts']) {
        if (
          isProductActive(
            isMaster,
            customerAlias,
            customerDocument,
            hasUserWebAccess,
            userMetaData,
            'eppProducts',
            eppProduct.id
          )
        ) {
          for (const station of eppProduct.stations) {
            if (station.stationId == stationId) {
              if (
                isUserAllowedToAccessToProduct(
                  userMetaData,
                  eppProduct.id,
                  isUserAdminMode,
                  stationId,
                  true
                )
              ) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
}
